import { ChallansStatus, StatusType } from './enums'

export const statusConfig = {
  [StatusType.COMPLETE]: {
    statusImageSrc: 'https://acko-cms.ackoassets.com/Tick_ae108ad6f0.svg',
    statusText: 'Checked',
  },
  [StatusType.REQUIRES_APP]: {
    statusImageSrc: 'https://acko-cms.ackoassets.com/Warning_09758d9c8a.svg',
    statusText: 'Requires OTP',
  },
}

export const appRedirectionMock = {
  [ChallansStatus.EMPTY]: {
    heading: 'Unlock more with the ACKO app',
    cta: 'Download the app',
    perks: ['FREE and accurate traffic fines info every month', 'FASTag recharge, PUC expiry alerts', 'Improve your ACKO insurance rate'],
  },
  [ChallansStatus.SOME]: {
    heading: 'Clear traffic fines on the ACKO app',
    cta: 'Pay on the app',
    perks: ['Secure payments direct to RTO', 'Zero convenience fees', 'FREE monthly traffic fines report'],
  },
  [ChallansStatus.DEFAULT]: {
    heading: 'As per {{state}} Govt. website guidelines, OTP verification is required to check your fines.',
    cta: 'Verify with OTP on the app',
    perks: [],
  },
}
